(ns frontend.ui.page.lp-portal.report.pdf.controller
  (:require
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.buyout-x.pdf.view :as
    fund-buyout-x]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.buyout-x-v2.pdf.view :as
    fund-buyout-x-v2]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.boxi.pdf.view :as fund-boxi]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.infra.pdf.view :as fund-infra]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.credit.pdf.view :as fund-credit]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.credit-v2.pdf.view :as fund-credit-v2]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel.pdf.view :as fund-hotel]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.hotel-v2.pdf :as fund-hotel-v2]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.koke.pdf.view :as fund-koke]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi.pdf.view :as fund-resi]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.resi-v2.pdf :as fund-resi-v2]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.stockholm-living.pdf-view :as fund-stockholm-living]
   [frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.pdf.view :as fund-nre]
   [frontend.ui.component.lp-portal.report.body.feeder.feeder.pdf :as fund-feeder]
   [frontend.ui.component.lp-portal.report.body.feeder.endowment.pdf :as fund-endowment]
   [frontend.ui.component.lp-portal.report.body.invest-europe.fund.pdf :as fund-invest-europe]
   [frontend.ui.component.lp-portal.report.body.voima.fund.pdf.pdf :as fund-voima]
   [frontend.ui.component.lp-portal.report.body.sparkmind.fund.pdf.pdf :as fund-sparkmind]
   [frontend.ui.component.lp-portal.report.body.innovestor.fund.pdf.view :as fund-innovestor]
   [frontend.ui.component.lp-portal.report.body.innovestor.holding.pdf :as holding-innovestor]
   [frontend.ui.component.lp-portal.report.body.private-equity.fund.natural-capital.pdf.view :as fund-natural-capital]
   [frontend.ui.component.lp-portal.report.body.lifeline.fund.pdf :as lifeline-fund]
   [frontend.ui.component.lp-portal.report.body.lifeline.fund.fund-v.pdf :as lifeline-fund-v]
   [frontend.ui.component.lp-portal.report.body.lifeline.fund.fund-vi.pdf :as lifeline-fund-vi]

   [frontend.ui.component.lp-portal.report.body.private-equity.holding.company.pdf.view :as
    holding-company]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.special-company.pdf.view :as
    holding-special-company]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.company-exit.pdf.view :as
    holding-exit]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.new-investment-company.pdf.view
    :as holding-new-investment]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.infra-company.pdf.view :as
    holding-infra]
   [frontend.ui.component.lp-portal.report.body.private-equity.holding.credit-company.pdf :as
    holding-credit]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.property.pdf :as holding-nre]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.koke.pdf :as holding-koke]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.resi.pdf :as holding-resi]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.hotel.pdf.view :as
    holding-hotel]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.re-new-investment.pdf :as
    holding-re-investment]
   [frontend.ui.component.lp-portal.report.body.real-estate.holding.re-exit-property.pdf :as
    holding-re-exit]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.pdf.holding :as ie-holding]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.new-investment.pdf.view :as ie-new-investment]
   [frontend.ui.component.lp-portal.report.body.invest-europe.holding.exit.pdf.view :as ie-exit]
   [frontend.ui.component.lp-portal.report.body.sparkmind.holding.pdf :as sparkmind-holding]
   [frontend.ui.component.lp-portal.report.body.lifeline.holding.pdf :as lifeline-holding]
  ))

(defn fund-pages
  [template-type ui-data]
  (case template-type
    :lp-report-template/materials-only nil
    :lp-report-template.capman/private-equity-fund-buyout-x (fund-buyout-x/buyout-x-pages ui-data)
    :lp-report-template.capman/private-equity-fund-buyout-x-v2 (fund-buyout-x-v2/buyout-x-pages ui-data)
    :lp-report-template.capman/private-equity-fund-boxi (fund-boxi/boxi-pages ui-data)
    :lp-report-template.capman/infra-fund (fund-infra/infra-pages ui-data)
    :lp-report-template.capman/credit-fund (fund-credit/credit-pages (merge ui-data {:nest-logo? true}))
    :lp-report-template.capman/credit-fund-v2 (fund-credit-v2/credit-pages (merge ui-data {:nest-logo? true}))
    :lp-report-template.capman/credit-fund-v2-capman (fund-credit-v2/credit-pages ui-data)
    :lp-report-template.capman/credit-fund-v3 (fund-credit-v2/credit-pages-v3 ui-data)
    :lp-report-template.capman/dasos-natural-capital (fund-natural-capital/natural-capital-pages ui-data)
    :lp-report-template.capman/dasos-natural-capital-FIN (fund-natural-capital/natural-capital-pages
                                                          (merge ui-data {:language :FI}))

    :lp-report-template.capman/real-estate-fund-hotels (fund-hotel/hotel-pages ui-data)
    :lp-report-template.capman/real-estate-fund-hotels-v2 (fund-hotel-v2/fund-pages ui-data)
    :lp-report-template.capman/real-estate-fund-hotels-v3 (fund-hotel-v2/fund-pages-v3 ui-data)
    :lp-report-template.capman/real-estate-fund-koke (fund-koke/koke-pages ui-data)
    :lp-report-template.capman/real-estate-fund-nre (fund-nre/nre-pages ui-data)
    :lp-report-template.capman/real-estate-fund-resi (fund-resi/resi-pages ui-data)
    :lp-report-template.capman/real-estate-fund-resi-v2 (fund-resi-v2/fund-pages ui-data)
    :lp-report-template.capman/real-estate-fund-stockholm-living (fund-stockholm-living/stockholm-living-pages ui-data)

    :lp-report-template.capman/feeder-fund (fund-feeder/report-pages ui-data)
    :lp-report-template.capman/endowment-fund (fund-endowment/report-pages ui-data)

    :lp-report-template.invest-europe/fund (fund-invest-europe/invest-europe-pages ui-data)

    :lp-report-template.voima/fund (fund-voima/voima-pages ui-data)

    :lp-report-template.sparkmind/fund (fund-sparkmind/sparkmind-pages ui-data)

    :lp-report-template.innovestor/fund (fund-innovestor/innovestor-pages ui-data)
    :lp-report-template.innovestor/feeder-fund (fund-innovestor/innovestor-feeder-pages ui-data)
    :lp-report-template.innovestor/technology-fund (fund-innovestor/innovestor-tech-fund-pages ui-data)
    :lp-report-template.innovestor/technology-fund-v2 (fund-innovestor/innovestor-tech-fund-pages ui-data)
    :lp-report-template.lifeline/fund (lifeline-fund/fund-pages ui-data)
    :lp-report-template.lifeline/fund-v (lifeline-fund-v/fund-pages ui-data)
    :lp-report-template.lifeline/fund-vi (lifeline-fund-vi/fund-pages ui-data)
    (js/console.log "NO such PDF template " template-type)))

(defn holding-pages
  [template-type ui-data]
  (case template-type
    :lp-report-holding-template.capman/private-equity-company (holding-company/holding-pages ui-data)
    :lp-report-holding-template.capman/private-equity-special-situations (holding-special-company/holding-pages ui-data)
    :lp-report-holding-template.capman/private-equity-exit-company (holding-exit/holding-pages ui-data)
    :lp-report-holding-template.capman/private-equity-investment-company (holding-new-investment/holding-pages ui-data)
    :lp-report-holding-template.capman/natural-capital-investment (holding-new-investment/dasos-holding-pages ui-data)
    :lp-report-holding-template.capman/infra-company (holding-infra/holding-pages ui-data)
    :lp-report-holding-template.capman/credit-company (holding-credit/holding-pages ui-data)

    :lp-report-holding-template.capman/real-estate-property-nre (holding-nre/holding-pages ui-data)
    :lp-report-holding-template.capman/real-estate-property-nre-esg (holding-nre/holding-pages-esg ui-data)
    :lp-report-holding-template.capman/real-estate-portfolio-nre-esg (holding-nre/holding-pages-portfolio-esg ui-data)
    :lp-report-holding-template.capman/real-estate-portfolio-hotels (holding-hotel/hotel-pages ui-data)
    :lp-report-holding-template.capman/real-estate-portfolio-hotels-esg (holding-hotel/hotel-pages-portfolio-esg ui-data)
    :lp-report-holding-template.capman/real-estate-property-hotels-esg (holding-hotel/hotel-pages-property-esg ui-data)
    :lp-report-holding-template.capman/real-estate-portfolio-koke (holding-koke/holding-pages ui-data)
    :lp-report-holding-template.capman/real-estate-portfolio-koke-esg (holding-koke/holding-pages-portfolio-esg ui-data)
    :lp-report-holding-template.capman/real-estate-property-koke-esg (holding-koke/holding-pages-property-esg ui-data)
    :lp-report-holding-template.capman/real-estate-portfolio-resi (holding-resi/holding-pages ui-data)
    :lp-report-holding-template.capman/real-estate-portfolio-resi-esg (holding-resi/holding-pages-portfolio-esg ui-data)
    :lp-report-holding-template.capman/real-estate-property-resi-esg (holding-resi/holding-pages-property-esg ui-data)
    :lp-report-holding-template.capman/real-estate-property-stockholm-living (holding-resi/holding-pages-stockholm-living ui-data)
    :lp-report-holding-template.capman/real-estate-new-investment (holding-re-investment/holding-pages ui-data)
    :lp-report-holding-template.capman/real-estate-exit-property (holding-re-exit/holding-pages ui-data)

    :lp-report-holding-template.invest-europe/holding (ie-holding/holding-pages ui-data)
    :lp-report-holding-template.invest-europe/new-investment (ie-new-investment/new-investment-pages ui-data)
    :lp-report-holding-template.invest-europe/exit (ie-exit/exit-pages ui-data)

    :lp-report-holding-template.sparkmind/private-equity-company (sparkmind-holding/holding-pages ui-data)

    :lp-report-holding-template.innovestor/holding (holding-innovestor/holding-pages ui-data)
    :lp-report-holding-template.innovestor/technology-fund-holding (holding-innovestor/tech-holding-pages ui-data)
    :lp-report-holding-template.innovestor/technology-fund-holding-v2 (holding-innovestor/tech-holding-pages ui-data)
    :lp-report-holding-template.lifeline/holding (lifeline-holding/holding-pages ui-data)
    :lp-report-holding-template.lifeline/exited-holding (lifeline-holding/exited-holding-pages ui-data)
    nil))

(defn last-pages
  [template-type ui-data]
  (case template-type
    :lp-report-template.voima/fund (fund-voima/voima-last-pages ui-data)
    :lp-report-template.sparkmind/fund (fund-sparkmind/sparkmind-last-pages ui-data)
    nil))
